import { Container, Image, SimpleGrid, Text, ThemeIcon } from '@mantine/core';
import { IconDownload } from '@sloyd/icons';
import { Button } from '../Button/Button';
import data from './Plugins.data.json';
import classes from './Plugins.module.css';
import { Wrapper } from './Plugins.style';

export type PluginsProps = {};

export function Plugins(_props: PluginsProps) {
  const items = (data as Json[]).map((item) => (
    <div className={classes.item} key={item.image}>
      <ThemeIcon variant='filled' className={classes.itemIcon} size={80} radius='md'>
        <Image src={item.imageUrl} />
      </ThemeIcon>

      <div>
        <Text fw={700} fz='lg' className={classes.itemTitle}>
          {item.title}
        </Text>
        <Text c='dimmed'>{item.description}</Text>
        <Button radius='xl' className={classes.cta} leftSection={<IconDownload />}>
          Download
        </Button>
      </div>
    </div>
  ));

  return (
    <Wrapper className='Plugins-wrapper' data-testid='Plugins-wrapper'>
      <Container size={700} className={classes.wrapper}>
        <SimpleGrid cols={{ base: 1, xs: 2 }} spacing={50} mt={30}>
          {items}
        </SimpleGrid>
      </Container>
    </Wrapper>
  );
}

export default Plugins;
